module.exports = __webpack_public_path__ + "static/media/ryan_crowley_fun.d309bb6a.png";